export default __webpack_public_path__ + "static/media/Samtokin-78_isl_Landscape_RGB.c74dcad6.webp";